/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  GenericScalar: any;
  JSONString: any;
  UUID: string;
  Upload: any;
};

export type ActivityInput = {
  icon: Scalars['String'];
  isFeatured: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ActivityStreamGenericType = SessionType | UserType;

export type ActivityStreamType = {
  __typename: 'ActivityStreamType';
  action?: Maybe<ActivityStreamGenericType>;
  actor?: Maybe<ActivityStreamGenericType>;
  id?: Maybe<Scalars['Int']>;
  target?: Maybe<ActivityStreamGenericType>;
  timesince?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  verb?: Maybe<Scalars['String']>;
};

export type ActivityType = {
  __typename: 'ActivityType';
  /** 700x400 */
  defaultBannerImage: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  isFeatured: Scalars['Boolean'];
  name: Scalars['String'];
  sessions: Array<SessionType>;
  userSet: Array<UserType>;
};

export type ActivityUpdateInput = {
  icon?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ApproveRejectRequestJoinGroup = {
  __typename: 'ApproveRejectRequestJoinGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type ApproveRejectRequestJoinGroupInput = {
  accept: Scalars['Boolean'];
  groupUuid: Scalars['String'];
  requestUserId: Scalars['Int'];
};

export type CancelSession = {
  __typename: 'CancelSession';
  ok: Scalars['Boolean'];
};

export type CancelSessionInput = {
  reason?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
};

export type CreateActivity = {
  __typename: 'CreateActivity';
  activity?: Maybe<ActivityType>;
  ok: Scalars['Boolean'];
};

export type CreateEntryInput = {
  message: Scalars['String'];
};

export type CreateFeedbackEntry = {
  __typename: 'CreateFeedbackEntry';
  entry?: Maybe<EntryType>;
  ok: Scalars['Boolean'];
};

export type CreateGroup = {
  __typename: 'CreateGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type CreateGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreatePostInput = {
  content: Scalars['String'];
  groupUuid: Scalars['ID'];
  parentUuid?: InputMaybe<Scalars['ID']>;
};

/** create a new wall post */
export type CreatePostMutation = {
  __typename: 'CreatePostMutation';
  ok: Scalars['Boolean'];
  post: WallPostType;
};

export type CreateSessionDateInput = {
  endAt: Scalars['DateTime'];
  startAt: Scalars['DateTime'];
};

export type CreateSessionMultipleInput = {
  activityId: Scalars['Int'];
  address: Scalars['String'];
  addressLatitude: Scalars['Float'];
  addressLongitude: Scalars['Float'];
  dates: Array<InputMaybe<CreateSessionDateInput>>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<SessionGenderEnum>;
  groupUuid: Scalars['String'];
  image?: InputMaybe<Scalars['Upload']>;
  isAcceptingCash?: InputMaybe<Scalars['Boolean']>;
  isOwnerAttending?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  maxAge?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  minAge?: InputMaybe<Scalars['Int']>;
  minParticipants?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  prices: Array<InputMaybe<PriceInput>>;
  refundPolicy: SessionRefundPolicyEnum;
  rules?: InputMaybe<Scalars['String']>;
  skillLevel: SessionSkillLevelEnum;
  venueType: SessionVenueTypeEnum;
};

export type CreateSessionsMultiple = {
  __typename: 'CreateSessionsMultiple';
  ok: Scalars['Boolean'];
  sessions?: Maybe<Array<Maybe<SessionType>>>;
};

export type CreateUpdateTrackTraceGroup = {
  __typename: 'CreateUpdateTrackTraceGroup';
  ok: Scalars['Boolean'];
};

export type CreateUpdateTrackTraceGroupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  groupUuid: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CreateUser = {
  __typename: 'CreateUser';
  token: Scalars['String'];
  user: MeType;
};

export type CreateUserInput = {
  activities?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
};

export type DeletePostInput = {
  postUuid?: InputMaybe<Scalars['ID']>;
};

/** Delete a post on a wall */
export type DeletePostMutation = {
  __typename: 'DeletePostMutation';
  ok: Scalars['Boolean'];
};

export type DeleteUser = {
  __typename: 'DeleteUser';
  ok: Scalars['Boolean'];
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename: 'DjangoDebug';
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type EditPostInput = {
  content: Scalars['String'];
  postUuid: Scalars['ID'];
};

/** create anew wall post */
export type EditPostMutation = {
  __typename: 'EditPostMutation';
  ok: Scalars['Boolean'];
  post?: Maybe<WallPostType>;
};

export type EntryType = {
  __typename: 'EntryType';
  createdAt: Scalars['DateTime'];
  createdBy: UserType;
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  message: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GroupRequestType = {
  __typename: 'GroupRequestType';
  createdAt: Scalars['DateTime'];
  group: GroupType;
  id: Scalars['ID'];
  requestUser: UserType;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type GroupType = {
  __typename: 'GroupType';
  activities?: Maybe<Array<Maybe<ActivityType>>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  groupRequests: Array<GroupRequestType>;
  groupUsers?: Maybe<Array<Maybe<GroupUserType>>>;
  hasRequested?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image: Scalars['String'];
  isActive: Scalars['Boolean'];
  /** Indicates if the current logged is an admin of the group */
  isAdmin: Scalars['Boolean'];
  /** Indicates if the current logged is a member of the group */
  isMember: Scalars['Boolean'];
  /** Indicates if the current logged in user the owner of the group */
  isOwner: Scalars['Boolean'];
  /** User has to request to join */
  isPrivate: Scalars['Boolean'];
  /** Is the group searchable */
  isSearchable: Scalars['Boolean'];
  /** The name of the group */
  name: Scalars['String'];
  sessions: Array<SessionType>;
  updatedAt: Scalars['DateTime'];
  userCount?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
  wall?: Maybe<WallType>;
};

export type GroupUserType = {
  __typename: 'GroupUserType';
  createdAt: Scalars['DateTime'];
  group: GroupType;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  user: UserType;
  uuid: Scalars['UUID'];
};

export type JoinGroup = {
  __typename: 'JoinGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type JoinGroupInput = {
  groupUuid: Scalars['String'];
};

export type JoinSession = {
  __typename: 'JoinSession';
  membership?: Maybe<MembershipType>;
  ok: Scalars['Boolean'];
};

export type JoinSessionInput = {
  isExpo?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  priceId?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['Int'];
};

export type JoinSessionWaitingList = {
  __typename: 'JoinSessionWaitingList';
  membership?: Maybe<MembershipType>;
  ok: Scalars['Boolean'];
};

export type JoinSessionWaitingListInput = {
  sessionId: Scalars['Int'];
};

export type LeaveGroup = {
  __typename: 'LeaveGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type LeaveGroupInput = {
  groupUuid: Scalars['String'];
};

export type LeaveSession = {
  __typename: 'LeaveSession';
  ok: Scalars['Boolean'];
};

export type LeaveSessionInput = {
  sessionId: Scalars['Int'];
};

export type LinkInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type LinkType = {
  __typename: 'LinkType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  session?: Maybe<SessionType>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type ManagementMutation = {
  __typename: 'ManagementMutation';
  ok: Scalars['Boolean'];
  response?: Maybe<Scalars['String']>;
};

export type MeType = {
  __typename: 'MeType';
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountSortCode: Scalars['String'];
  activities: Array<ActivityType>;
  attendingSessionCount?: Maybe<Scalars['Int']>;
  avatar: Scalars['String'];
  dateJoined: Scalars['DateTime'];
  defaultAddress: Scalars['String'];
  defaultAddressLatitude?: Maybe<Scalars['Float']>;
  defaultAddressLongitude?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  groupuserSet: Array<GroupUserType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isOrfiVerified: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  isTester: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  membershipSet: Array<MembershipType>;
  name: Scalars['String'];
  organisedEventsCount?: Maybe<Scalars['Int']>;
  owner: Array<SessionType>;
  passwordResetCode: Scalars['String'];
  postReactions: Array<WallReactionType>;
  pushNotificationToken: Scalars['String'];
  streamToken?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  useDefaultAddress: Scalars['Boolean'];
  uuid?: Maybe<Scalars['UUID']>;
  verificationCode: Scalars['String'];
  walls: Array<WallPostType>;
};

/** An enumeration. */
export enum MembershipPaymentMethod {
  /** All */
  All = 'ALL',
  /** App */
  App = 'APP',
  /** On Site */
  Site = 'SITE'
}

/** An enumeration. */
export enum MembershipStatus {
  /** 4. Attending */
  Attending = 'ATTENDING',
  /** 1. Invited */
  Invited = 'INVITED',
  /** 3.1 Payment Pending */
  PaymentPending = 'PAYMENT_PENDING',
  /** 3.2 Payment Processing */
  PaymentProcessing = 'PAYMENT_PROCESSING',
  /** 2. Waiting */
  Waiting = 'WAITING'
}

export enum MembershipStatusEnum {
  Attending = 'ATTENDING',
  Invited = 'INVITED',
  PaymentPending = 'PAYMENT_PENDING',
  Waiting = 'WAITING'
}

export type MembershipType = {
  __typename: 'MembershipType';
  attendance?: Maybe<Scalars['Boolean']>;
  bankedPaymentId?: Maybe<Scalars['String']>;
  bankedPaymentStatus?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  paymentMethod?: Maybe<MembershipPaymentMethod>;
  price?: Maybe<PriceType>;
  session: SessionType;
  status: MembershipStatus;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  uuid: Scalars['UUID'];
};

export type Mutation = {
  __typename: 'Mutation';
  approveRejectRequestJoinGroup?: Maybe<ApproveRejectRequestJoinGroup>;
  cancelSession?: Maybe<CancelSession>;
  createActivity?: Maybe<CreateActivity>;
  createFeedbackEntry?: Maybe<CreateFeedbackEntry>;
  createGroup?: Maybe<CreateGroup>;
  createMultipleSessions?: Maybe<CreateSessionsMultiple>;
  createUpdateTrackTraceGroup?: Maybe<CreateUpdateTrackTraceGroup>;
  createUser: CreateUser;
  deleteUser: DeleteUser;
  joinGroup?: Maybe<JoinGroup>;
  joinSession?: Maybe<JoinSession>;
  joinSessionWaitingList?: Maybe<JoinSessionWaitingList>;
  leaveGroup?: Maybe<LeaveGroup>;
  leaveSession?: Maybe<LeaveSession>;
  management?: Maybe<ManagementMutation>;
  passwordReset: PasswordReset;
  refreshToken?: Maybe<Refresh>;
  removeMemberGroup?: Maybe<RemoveMemberGroup>;
  requestTrackTraceGroup?: Maybe<RequestTrackTrace>;
  sendPasswordResetEmail: SendPasswordResetEmail;
  sendVerificationEmail: SendVerificationEmail;
  setAdminGroup?: Maybe<SetGroupAdmin>;
  testUserNotification: TestUserNotification;
  /** Obtain JSON Web Token mutation */
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  transferGroupOwnership?: Maybe<TransferGroupOwnership>;
  transferSession?: Maybe<TransferSessionMembership>;
  updateActivity?: Maybe<UpdateActivity>;
  updateGroup?: Maybe<UpdateGroup>;
  updateSession?: Maybe<UpdateSession>;
  updateSessionAttendance?: Maybe<UpdateSessionMembershipAttendance>;
  updateUser: UpdateUser;
  uploadImage?: Maybe<UploadMutation>;
  verifyToken?: Maybe<Verify>;
  verifyUser: VerifyUser;
  /** create a new wall post */
  wallCreatePost: CreatePostMutation;
  /** Delete a post on a wall */
  wallDeletePost: DeletePostMutation;
  /** create anew wall post */
  wallEditPost: EditPostMutation;
  /** Create or Delete a post reaction */
  wallToggleReaction: ToggleReactionMutation;
};


export type MutationApproveRejectRequestJoinGroupArgs = {
  input: ApproveRejectRequestJoinGroupInput;
};


export type MutationCancelSessionArgs = {
  input: CancelSessionInput;
};


export type MutationCreateActivityArgs = {
  input: ActivityInput;
};


export type MutationCreateFeedbackEntryArgs = {
  input: CreateEntryInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateMultipleSessionsArgs = {
  input: CreateSessionMultipleInput;
};


export type MutationCreateUpdateTrackTraceGroupArgs = {
  input: CreateUpdateTrackTraceGroupInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationJoinGroupArgs = {
  input: JoinGroupInput;
};


export type MutationJoinSessionArgs = {
  input: JoinSessionInput;
};


export type MutationJoinSessionWaitingListArgs = {
  input: JoinSessionWaitingListInput;
};


export type MutationLeaveGroupArgs = {
  input: LeaveGroupInput;
};


export type MutationLeaveSessionArgs = {
  input: LeaveSessionInput;
};


export type MutationManagementArgs = {
  command?: InputMaybe<Scalars['String']>;
};


export type MutationPasswordResetArgs = {
  input: PasswordResetInput;
};


export type MutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveMemberGroupArgs = {
  input: RemoveMemberGroupInput;
};


export type MutationRequestTrackTraceGroupArgs = {
  input: RequestTrackTraceGroupInput;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetInput;
};


export type MutationSetAdminGroupArgs = {
  input: SetGroupAdminInput;
};


export type MutationTestUserNotificationArgs = {
  userId: Scalars['Int'];
};


export type MutationTokenAuthArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationTransferGroupOwnershipArgs = {
  input: TransferGroupOwnershipInput;
};


export type MutationTransferSessionArgs = {
  input: TransferSessionMembershipInput;
};


export type MutationUpdateActivityArgs = {
  id: Scalars['Int'];
  input: ActivityUpdateInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateSessionAttendanceArgs = {
  input: UpdateSessionMembershipAttendanceInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload'];
};


export type MutationVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyUserArgs = {
  input: VerifyUserInput;
};


export type MutationWallCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationWallDeletePostArgs = {
  input: DeletePostInput;
};


export type MutationWallEditPostArgs = {
  input: EditPostInput;
};


export type MutationWallToggleReactionArgs = {
  input: ToggleReactionInput;
};

/** Obtain JSON Web Token mutation */
export type ObtainJsonWebToken = {
  __typename: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type PasswordReset = {
  __typename: 'PasswordReset';
  ok: Scalars['Boolean'];
};

export type PasswordResetInput = {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type PriceInput = {
  description: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type PriceType = {
  __typename: 'PriceType';
  description: Scalars['String'];
  id: Scalars['ID'];
  session?: Maybe<SessionType>;
  sessions: Array<MembershipType>;
  uuid: Scalars['UUID'];
  value: Scalars['Float'];
};

export type Query = {
  __typename: 'Query';
  _debug?: Maybe<DjangoDebug>;
  activities?: Maybe<Array<Maybe<ActivityType>>>;
  activity?: Maybe<ActivityType>;
  attendingSessions?: Maybe<Array<SessionType>>;
  group?: Maybe<GroupType>;
  groupRequests?: Maybe<Array<Maybe<GroupRequestType>>>;
  groupSearch: Array<Maybe<GroupType>>;
  historicAttendingSessions?: Maybe<Array<SessionType>>;
  me: MeType;
  membership?: Maybe<MembershipType>;
  organisedSessions?: Maybe<Array<SessionType>>;
  pendingSessions?: Maybe<Array<SessionType>>;
  session: SessionType;
  sessionMembership?: Maybe<Array<MembershipType>>;
  user?: Maybe<UserType>;
  userActivityStream?: Maybe<Array<Maybe<ActivityStreamType>>>;
  userNotifications: Array<Maybe<UserNotificationType>>;
  users?: Maybe<Array<Maybe<UserType>>>;
  /** Get a single post */
  wallPost: WallPostType;
  /** Users can fetch posts from a group wall if they are a member of the group */
  wallPosts: Array<WallPostType>;
};


export type QueryActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGroupArgs = {
  groupUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGroupRequestsArgs = {
  groupUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGroupSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMembershipArgs = {
  id?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
};


export type QuerySessionArgs = {
  id: Scalars['Int'];
};


export type QuerySessionMembershipArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  startAt_Gte?: InputMaybe<Scalars['DateTime']>;
  startAt_Lte?: InputMaybe<Scalars['DateTime']>;
  status_In?: InputMaybe<Array<InputMaybe<MembershipStatusEnum>>>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryUserActivityStreamArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryWallPostArgs = {
  postUuid: Scalars['ID'];
};


export type QueryWallPostsArgs = {
  groupUuid: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentUuid?: InputMaybe<Scalars['ID']>;
};

export type Refresh = {
  __typename: 'Refresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type RemoveMemberGroup = {
  __typename: 'RemoveMemberGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type RemoveMemberGroupInput = {
  groupUuid: Scalars['String'];
  userId: Scalars['Int'];
};

export type RequestTrackTrace = {
  __typename: 'RequestTrackTrace';
  ok: Scalars['Boolean'];
};

export type RequestTrackTraceGroupInput = {
  groupUuid: Scalars['String'];
  sessionUuid: Scalars['String'];
};

export type SendPasswordResetEmail = {
  __typename: 'SendPasswordResetEmail';
  ok: Scalars['Boolean'];
};

export type SendPasswordResetInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type SendVerificationEmail = {
  __typename: 'SendVerificationEmail';
  ok: Scalars['Boolean'];
};

export enum SessionGenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Mixed = 'MIXED',
  Neutral = 'NEUTRAL'
}

/** An enumeration. */
export enum SessionPaymentMethod {
  /** All */
  All = 'ALL',
  /** App */
  App = 'APP',
  /** On Site */
  Site = 'SITE'
}

export enum SessionPaymentMethodEnum {
  All = 'ALL',
  App = 'APP',
  Site = 'SITE'
}

/** An enumeration. */
export enum SessionRefundPolicy {
  /** Full */
  Full = 'FULL',
  /** None */
  None = 'NONE',
  /** Partial */
  Partial = 'PARTIAL'
}

export enum SessionRefundPolicyEnum {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

/** An enumeration. */
export enum SessionSkillLevel {
  /** Beginner */
  Beginner = 'BEGINNER',
  /** Intermediate */
  Intermediate = 'INTERMEDIATE',
  /** Open */
  Open = 'OPEN',
  /** Pro */
  Pro = 'PRO'
}

export enum SessionSkillLevelEnum {
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  Open = 'OPEN',
  Pro = 'PRO'
}

export type SessionType = {
  __typename: 'SessionType';
  activity: Array<Maybe<ActivityType>>;
  address: Scalars['String'];
  addressLatitude?: Maybe<Scalars['Float']>;
  addressLongitude?: Maybe<Scalars['Float']>;
  cancellationReason: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  endAt?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  group: GroupType;
  id: Scalars['ID'];
  image: Scalars['String'];
  isAcceptingCash?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isJoinable: Scalars['Boolean'];
  isManaged: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  isOwnerAttending?: Maybe<Scalars['Boolean']>;
  isPrivate: Scalars['Boolean'];
  isUserAttending: Scalars['Boolean'];
  links?: Maybe<Array<LinkType>>;
  maxAge?: Maybe<Scalars['Int']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  membership: Array<MembershipType>;
  membershipAttending?: Maybe<Array<MembershipType>>;
  membershipInvited?: Maybe<Array<MembershipType>>;
  minAge?: Maybe<Scalars['Int']>;
  minParticipants?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  owner?: Maybe<UserType>;
  paymentMethod: SessionPaymentMethod;
  prices?: Maybe<Array<PriceType>>;
  refundPolicy: SessionRefundPolicy;
  rules: Scalars['String'];
  skillLevel: SessionSkillLevel;
  startAt: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usersAttendingCount: Scalars['Int'];
  uuid: Scalars['UUID'];
  venueType: SessionVenueType;
};

/** An enumeration. */
export enum SessionVenueType {
  /** Indoor */
  Indoor = 'INDOOR',
  /** Outdoor */
  Outdoor = 'OUTDOOR'
}

export enum SessionVenueTypeEnum {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export type SetGroupAdmin = {
  __typename: 'SetGroupAdmin';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type SetGroupAdminInput = {
  groupUuid: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type TestUserNotification = {
  __typename: 'TestUserNotification';
  ok: Scalars['Boolean'];
};

export type ToggleReactionInput = {
  postUuid: Scalars['ID'];
};

/** Create or Delete a post reaction */
export type ToggleReactionMutation = {
  __typename: 'ToggleReactionMutation';
  ok: Scalars['Boolean'];
  post?: Maybe<WallPostType>;
};

export type TransferGroupOwnership = {
  __typename: 'TransferGroupOwnership';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type TransferGroupOwnershipInput = {
  groupUuid: Scalars['String'];
  userId: Scalars['Int'];
};

export type TransferSessionMembership = {
  __typename: 'TransferSessionMembership';
  membership?: Maybe<MembershipType>;
  ok: Scalars['Boolean'];
};

export type TransferSessionMembershipInput = {
  membershipUuid: Scalars['String'];
  priceUuid: Scalars['String'];
};

export type UpdateActivity = {
  __typename: 'UpdateActivity';
  activity?: Maybe<ActivityType>;
  ok: Scalars['Boolean'];
};

export type UpdateGroup = {
  __typename: 'UpdateGroup';
  group?: Maybe<GroupType>;
  ok: Scalars['Boolean'];
};

export type UpdateGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  groupUuid: Scalars['String'];
  image?: InputMaybe<Scalars['Upload']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSession = {
  __typename: 'UpdateSession';
  ok: Scalars['Boolean'];
  session?: Maybe<SessionType>;
};

export type UpdateSessionInput = {
  activityId?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressLatitude?: InputMaybe<Scalars['Float']>;
  addressLongitude?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  gender?: InputMaybe<SessionGenderEnum>;
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  isAcceptingCash?: InputMaybe<Scalars['Boolean']>;
  isOwnerAttending?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  maxAge?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  minAge?: InputMaybe<Scalars['Int']>;
  minParticipants?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  refundPolicy?: InputMaybe<SessionRefundPolicyEnum>;
  rules?: InputMaybe<Scalars['String']>;
  skillLevel?: InputMaybe<SessionSkillLevelEnum>;
  startAt: Scalars['DateTime'];
  venueType?: InputMaybe<SessionVenueTypeEnum>;
};

export type UpdateSessionMembershipAttendance = {
  __typename: 'UpdateSessionMembershipAttendance';
  membership?: Maybe<MembershipType>;
  ok: Scalars['Boolean'];
};

export type UpdateSessionMembershipAttendanceInput = {
  attendance: Scalars['Boolean'];
  sessionUuid: Scalars['String'];
  userId: Scalars['Int'];
};

export type UpdateUser = {
  __typename: 'UpdateUser';
  user?: Maybe<MeType>;
};

export type UpdateUserInput = {
  accountName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountSortCode?: InputMaybe<Scalars['String']>;
  activities?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAddress?: InputMaybe<Scalars['String']>;
  defaultAddressLatitude?: InputMaybe<Scalars['Float']>;
  defaultAddressLongitude?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newAvatar?: InputMaybe<Scalars['Upload']>;
  newPassword?: InputMaybe<Scalars['String']>;
  pushNotificationToken?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  useDefaultAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UploadMutation = {
  __typename: 'UploadMutation';
  ok: Scalars['Boolean'];
};

export type UserNotificationType = {
  __typename: 'UserNotificationType';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONString']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  uuid?: Maybe<Scalars['String']>;
};

export type UserType = {
  __typename: 'UserType';
  activities: Array<ActivityType>;
  attendingSessionCount?: Maybe<Scalars['Int']>;
  avatar: Scalars['String'];
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  groupuserSet: Array<GroupUserType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isOrfiVerified: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  isTester: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  membershipSet: Array<MembershipType>;
  name: Scalars['String'];
  organisedEventsCount?: Maybe<Scalars['Int']>;
  owner: Array<SessionType>;
  postReactions: Array<WallReactionType>;
  surname: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
  walls: Array<WallPostType>;
};

export type Verify = {
  __typename: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type VerifyUser = {
  __typename: 'VerifyUser';
  me?: Maybe<MeType>;
  ok: Scalars['Boolean'];
};

export type VerifyUserInput = {
  code: Scalars['String'];
};

export type WallPostType = {
  __typename: 'WallPostType';
  /** 256 characters maximal or fewer */
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Indicates if author is an admin */
  isAdmin: Scalars['Boolean'];
  /** Parent Post UUID */
  parent?: Maybe<WallPostType>;
  postCount: Scalars['Int'];
  /** Parent Post UUID */
  posts: Array<WallPostType>;
  reactionCount: Scalars['Int'];
  reactions: Array<WallReactionType>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  /** Indicates if the logged in user has liked the post */
  userHasLiked: Scalars['Boolean'];
  uuid: Scalars['UUID'];
  wall: WallType;
};

export type WallReactionType = {
  __typename: 'WallReactionType';
  createdAt: Scalars['DateTime'];
  post: WallPostType;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  uuid: Scalars['UUID'];
};

export type WallType = {
  __typename: 'WallType';
  createdAt: Scalars['DateTime'];
  group: GroupType;
  isActive: Scalars['Boolean'];
  posts: Array<WallPostType>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type SessionFragment = { __typename: 'SessionType', id: string, uuid: string, createdAt: string, name: string, image: string, startAt: string, endAt?: string | null, status?: string | null, usersAttendingCount: number, isUserAttending: boolean, isJoinable: boolean, gender?: string | null, skillLevel: SessionSkillLevel, venueType: SessionVenueType, minAge?: number | null, maxAge?: number | null, minParticipants?: number | null, maxParticipants?: number | null, address: string, addressLatitude?: number | null, addressLongitude?: number | null, description: string, cancellationReason: string, rules: string, notes: string, isPrivate: boolean, paymentMethod: SessionPaymentMethod, isOwner: boolean, membership: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', uuid?: string | null, id: string, name: string, surname: string, avatar: string }, price?: { __typename: 'PriceType', id: string, uuid: string, value: number, description: string } | null }>, membershipAttending?: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } }> | null, owner?: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null>, links?: Array<{ __typename: 'LinkType', id: string, name: string, url: string }> | null, prices?: Array<{ __typename: 'PriceType', id: string, uuid: string, description: string, value: number }> | null, group: { __typename: 'GroupType', id: string, uuid: string, isPrivate: boolean, isMember: boolean, isOwner: boolean, isAdmin: boolean, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, name: string, endAt?: string | null }> } };

export type MeUserFragment = { __typename: 'MeType', id: string, uuid?: string | null, name: string, surname: string, email: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, defaultAddress: string, defaultAddressLatitude?: number | null, defaultAddressLongitude?: number | null, useDefaultAddress: boolean, accountName: string, accountNumber: string, accountSortCode: string, passwordResetCode: string, verificationCode: string, isEmailVerified: boolean, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isActive: boolean, isPrivate: boolean, isOwner: boolean, isMember: boolean, isAdmin: boolean, hasRequested?: boolean | null, userCount?: boolean | null, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, paymentMethod: SessionPaymentMethod }>, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null, groupUsers?: Array<{ __typename: 'GroupUserType', id: string } | null> | null } }> };

export type UserFragment = { __typename: 'UserType', id: string, uuid?: string | null, name: string, surname: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isAdmin: boolean, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } }> };

export type GroupFragment = { __typename: 'GroupType', id: string, uuid: string, createdAt: string, updatedAt: string, name: string, image: string, isOwner: boolean, isAdmin: boolean, isActive: boolean, isMember: boolean, isPrivate: boolean, description: string, userCount?: boolean | null, hasRequested?: boolean | null, groupUsers?: Array<{ __typename: 'GroupUserType', id: string, isAdmin: boolean, createdAt: string, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string, email: string } } | null> | null, groupRequests: Array<{ __typename: 'GroupRequestType', uuid: string, createdAt: string, updatedAt: string, id: string }>, sessions: Array<{ __typename: 'SessionType', id: string, uuid: string, name: string, image: string, address: string, status?: string | null, isUserAttending: boolean, startAt: string, endAt?: string | null, maxParticipants?: number | null, usersAttendingCount: number, activity: Array<{ __typename: 'ActivityType', id: string, defaultBannerImage: string, name: string } | null>, owner?: { __typename: 'UserType', id: string, name: string } | null, membership: Array<{ __typename: 'MembershipType', id: string, status: MembershipStatus }> }>, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null };

export type WallPostFragment = { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean };

export type WallFragment = { __typename: 'WallType', uuid: string, group: { __typename: 'GroupType', uuid: string, isAdmin: boolean, isOwner: boolean } };

export type LoginMutationMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutationMutation = { __typename: 'Mutation', tokenAuth?: { __typename: 'ObtainJSONWebToken', token: string } | null };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  activities?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  avatar?: InputMaybe<Scalars['Upload']>;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: { __typename: 'CreateUser', token: string, user: { __typename: 'MeType', id: string, name: string, surname: string, email: string, avatar: string, isEmailVerified: boolean, activities: Array<{ __typename: 'ActivityType', id: string, name: string }> } } };

export type UpdateUserMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  newAvatar?: InputMaybe<Scalars['Upload']>;
  accountName: Scalars['String'];
  accountNumber?: InputMaybe<Scalars['String']>;
  accountSortCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser: { __typename: 'UpdateUser', user?: { __typename: 'MeType', id: string, name: string, surname: string, email: string, avatar: string, accountSortCode: string, activities: Array<{ __typename: 'ActivityType', id: string, name: string }> } | null } };

export type UpdateUserPushMutationVariables = Exact<{
  pushNotificationToken?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPushMutation = { __typename: 'Mutation', updateUser: { __typename: 'UpdateUser', user?: { __typename: 'MeType', id: string } | null } };

export type CreateMultipleSessionsMutationVariables = Exact<{
  name: Scalars['String'];
  groupUuid: Scalars['String'];
  activityId: Scalars['Int'];
  prices: Array<InputMaybe<PriceInput>> | InputMaybe<PriceInput>;
  links?: InputMaybe<Array<InputMaybe<LinkInput>> | InputMaybe<LinkInput>>;
  gender?: InputMaybe<SessionGenderEnum>;
  skillLevel: SessionSkillLevelEnum;
  venueType: SessionVenueTypeEnum;
  refundPolicy: SessionRefundPolicyEnum;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  minAge?: InputMaybe<Scalars['Int']>;
  maxAge?: InputMaybe<Scalars['Int']>;
  minParticipants?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  address: Scalars['String'];
  addressLatitude: Scalars['Float'];
  addressLongitude: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isAcceptingCash?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['Upload']>;
  dates: Array<InputMaybe<CreateSessionDateInput>> | InputMaybe<CreateSessionDateInput>;
}>;


export type CreateMultipleSessionsMutation = { __typename: 'Mutation', createMultipleSessions?: { __typename: 'CreateSessionsMultiple', ok: boolean } | null };

export type UpdateSessionWithImageMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  activityId?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<SessionGenderEnum>;
  skillLevel: SessionSkillLevelEnum;
  venueType: SessionVenueTypeEnum;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  image?: InputMaybe<Scalars['Upload']>;
  minAge?: InputMaybe<Scalars['Int']>;
  maxAge?: InputMaybe<Scalars['Int']>;
  minParticipants?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  address: Scalars['String'];
  addressLatitude: Scalars['Float'];
  addressLongitude: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['DateTime'];
  endAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateSessionWithImageMutation = { __typename: 'Mutation', updateSession?: { __typename: 'UpdateSession', ok: boolean, session?: { __typename: 'SessionType', id: string, uuid: string, createdAt: string, name: string, image: string, startAt: string, endAt?: string | null, status?: string | null, usersAttendingCount: number, isUserAttending: boolean, isJoinable: boolean, gender?: string | null, skillLevel: SessionSkillLevel, venueType: SessionVenueType, minAge?: number | null, maxAge?: number | null, minParticipants?: number | null, maxParticipants?: number | null, address: string, addressLatitude?: number | null, addressLongitude?: number | null, description: string, cancellationReason: string, rules: string, notes: string, isPrivate: boolean, paymentMethod: SessionPaymentMethod, isOwner: boolean, membership: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', uuid?: string | null, id: string, name: string, surname: string, avatar: string }, price?: { __typename: 'PriceType', id: string, uuid: string, value: number, description: string } | null }>, membershipAttending?: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } }> | null, owner?: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null>, links?: Array<{ __typename: 'LinkType', id: string, name: string, url: string }> | null, prices?: Array<{ __typename: 'PriceType', id: string, uuid: string, description: string, value: number }> | null, group: { __typename: 'GroupType', id: string, uuid: string, isPrivate: boolean, isMember: boolean, isOwner: boolean, isAdmin: boolean, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, name: string, endAt?: string | null }> } } | null } | null };

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  activityId?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<SessionGenderEnum>;
  skillLevel: SessionSkillLevelEnum;
  venueType: SessionVenueTypeEnum;
  paymentMethod?: InputMaybe<SessionPaymentMethodEnum>;
  minAge?: InputMaybe<Scalars['Int']>;
  maxAge?: InputMaybe<Scalars['Int']>;
  minParticipants?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  address: Scalars['String'];
  addressLatitude: Scalars['Float'];
  addressLongitude: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['DateTime'];
  endAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateSessionMutation = { __typename: 'Mutation', updateSession?: { __typename: 'UpdateSession', ok: boolean, session?: { __typename: 'SessionType', id: string, uuid: string, createdAt: string, name: string, image: string, startAt: string, endAt?: string | null, status?: string | null, usersAttendingCount: number, isUserAttending: boolean, isJoinable: boolean, gender?: string | null, skillLevel: SessionSkillLevel, venueType: SessionVenueType, minAge?: number | null, maxAge?: number | null, minParticipants?: number | null, maxParticipants?: number | null, address: string, addressLatitude?: number | null, addressLongitude?: number | null, description: string, cancellationReason: string, rules: string, notes: string, isPrivate: boolean, paymentMethod: SessionPaymentMethod, isOwner: boolean, membership: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', uuid?: string | null, id: string, name: string, surname: string, avatar: string }, price?: { __typename: 'PriceType', id: string, uuid: string, value: number, description: string } | null }>, membershipAttending?: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } }> | null, owner?: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null>, links?: Array<{ __typename: 'LinkType', id: string, name: string, url: string }> | null, prices?: Array<{ __typename: 'PriceType', id: string, uuid: string, description: string, value: number }> | null, group: { __typename: 'GroupType', id: string, uuid: string, isPrivate: boolean, isMember: boolean, isOwner: boolean, isAdmin: boolean, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, name: string, endAt?: string | null }> } } | null } | null };

export type JoinSessionMutationVariables = Exact<{
  priceId: Scalars['Int'];
  sessionId: Scalars['Int'];
  paymentMethod: SessionPaymentMethodEnum;
  isExpo?: InputMaybe<Scalars['Boolean']>;
}>;


export type JoinSessionMutation = { __typename: 'Mutation', joinSession?: { __typename: 'JoinSession', ok: boolean, membership?: { __typename: 'MembershipType', id: string, status: MembershipStatus, createdAt: string, updatedAt: string, bankedPaymentId?: string | null, bankedPaymentStatus?: string | null, session: { __typename: 'SessionType', id: string }, user: { __typename: 'UserType', id: string } } | null } | null };

export type JoinSessionWaitingListMutationVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type JoinSessionWaitingListMutation = { __typename: 'Mutation', joinSessionWaitingList?: { __typename: 'JoinSessionWaitingList', ok: boolean } | null };

export type LeaveSessionMutationVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type LeaveSessionMutation = { __typename: 'Mutation', leaveSession?: { __typename: 'LeaveSession', ok: boolean } | null };

export type CancelSessionMutationVariables = Exact<{
  sessionId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type CancelSessionMutation = { __typename: 'Mutation', cancelSession?: { __typename: 'CancelSession', ok: boolean } | null };

export type CreateFeedbackEntryMutationVariables = Exact<{
  message: Scalars['String'];
}>;


export type CreateFeedbackEntryMutation = { __typename: 'Mutation', createFeedbackEntry?: { __typename: 'CreateFeedbackEntry', ok: boolean, entry?: { __typename: 'EntryType', message: string } | null } | null };

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  isPrivate: Scalars['Boolean'];
}>;


export type CreateGroupMutation = { __typename: 'Mutation', createGroup?: { __typename: 'CreateGroup', ok: boolean, group?: { __typename: 'GroupType', uuid: string } | null } | null };

export type UpdateGroupWithImageMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  isPrivate: Scalars['Boolean'];
}>;


export type UpdateGroupWithImageMutation = { __typename: 'Mutation', updateGroup?: { __typename: 'UpdateGroup', ok: boolean, group?: { __typename: 'GroupType', uuid: string } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  isPrivate: Scalars['Boolean'];
}>;


export type UpdateGroupMutation = { __typename: 'Mutation', updateGroup?: { __typename: 'UpdateGroup', ok: boolean, group?: { __typename: 'GroupType', uuid: string } | null } | null };

export type LeaveGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
}>;


export type LeaveGroupMutation = { __typename: 'Mutation', leaveGroup?: { __typename: 'LeaveGroup', ok: boolean } | null };

export type JoinGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
}>;


export type JoinGroupMutation = { __typename: 'Mutation', joinGroup?: { __typename: 'JoinGroup', ok: boolean } | null };

export type ApproveRejectRequestJoinGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  requestUserId: Scalars['Int'];
  accept: Scalars['Boolean'];
}>;


export type ApproveRejectRequestJoinGroupMutation = { __typename: 'Mutation', approveRejectRequestJoinGroup?: { __typename: 'ApproveRejectRequestJoinGroup', ok: boolean } | null };

export type SetAdminGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  userId: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
}>;


export type SetAdminGroupMutation = { __typename: 'Mutation', setAdminGroup?: { __typename: 'SetGroupAdmin', ok: boolean } | null };

export type TransferGroupOwnershipMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type TransferGroupOwnershipMutation = { __typename: 'Mutation', transferGroupOwnership?: { __typename: 'TransferGroupOwnership', ok: boolean } | null };

export type RemoveMemberGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type RemoveMemberGroupMutation = { __typename: 'Mutation', removeMemberGroup?: { __typename: 'RemoveMemberGroup', ok: boolean } | null };

export type CreateUpdateTrackTraceGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
}>;


export type CreateUpdateTrackTraceGroupMutation = { __typename: 'Mutation', createUpdateTrackTraceGroup?: { __typename: 'CreateUpdateTrackTraceGroup', ok: boolean } | null };

export type RequestTrackTraceGroupMutationVariables = Exact<{
  groupUuid: Scalars['String'];
  sessionUuid: Scalars['String'];
}>;


export type RequestTrackTraceGroupMutation = { __typename: 'Mutation', requestTrackTraceGroup?: { __typename: 'RequestTrackTrace', ok: boolean } | null };

export type UpdateSessionAttendanceMutationVariables = Exact<{
  userId: Scalars['Int'];
  sessionUuid: Scalars['String'];
  attendance: Scalars['Boolean'];
}>;


export type UpdateSessionAttendanceMutation = { __typename: 'Mutation', updateSessionAttendance?: { __typename: 'UpdateSessionMembershipAttendance', ok: boolean } | null };

export type TransferSessionMutationVariables = Exact<{
  membershipUuid: Scalars['String'];
  priceUuid: Scalars['String'];
}>;


export type TransferSessionMutation = { __typename: 'Mutation', transferSession?: { __typename: 'TransferSessionMembership', ok: boolean } | null };

export type PasswordResetMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  password: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename: 'Mutation', passwordReset: { __typename: 'PasswordReset', ok: boolean } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type SendPasswordResetEmailMutation = { __typename: 'Mutation', sendPasswordResetEmail: { __typename: 'SendPasswordResetEmail', ok: boolean } };

export type VerifyUserMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type VerifyUserMutation = { __typename: 'Mutation', verifyUser: { __typename: 'VerifyUser', ok: boolean } };

export type SendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendVerificationEmailMutation = { __typename: 'Mutation', sendVerificationEmail: { __typename: 'SendVerificationEmail', ok: boolean } };

export type WallCreatePostMutationVariables = Exact<{
  groupUuid: Scalars['ID'];
  parentUuid?: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
}>;


export type WallCreatePostMutation = { __typename: 'Mutation', wallCreatePost: { __typename: 'CreatePostMutation', ok: boolean, post: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean, user: { __typename: 'UserType', id: string, uuid?: string | null, name: string, surname: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isAdmin: boolean, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } }> }, parent?: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean } | null, wall: { __typename: 'WallType', uuid: string, group: { __typename: 'GroupType', uuid: string, isAdmin: boolean, isOwner: boolean } } } } };

export type WallEditPostMutationVariables = Exact<{
  postUuid: Scalars['ID'];
  content: Scalars['String'];
}>;


export type WallEditPostMutation = { __typename: 'Mutation', wallEditPost: { __typename: 'EditPostMutation', ok: boolean, post?: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean } | null } };

export type WallDeletePostMutationVariables = Exact<{
  postUuid: Scalars['ID'];
}>;


export type WallDeletePostMutation = { __typename: 'Mutation', wallDeletePost: { __typename: 'DeletePostMutation', ok: boolean } };

export type WallToggleReactionMutationVariables = Exact<{
  postUuid: Scalars['ID'];
}>;


export type WallToggleReactionMutation = { __typename: 'Mutation', wallToggleReaction: { __typename: 'ToggleReactionMutation', ok: boolean, post?: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean } | null } };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUser: { __typename: 'DeleteUser', ok: boolean } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename: 'Query', me: { __typename: 'MeType', id: string, uuid?: string | null, name: string, surname: string, email: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, defaultAddress: string, defaultAddressLatitude?: number | null, defaultAddressLongitude?: number | null, useDefaultAddress: boolean, accountName: string, accountNumber: string, accountSortCode: string, passwordResetCode: string, verificationCode: string, isEmailVerified: boolean, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isActive: boolean, isPrivate: boolean, isOwner: boolean, isMember: boolean, isAdmin: boolean, hasRequested?: boolean | null, userCount?: boolean | null, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, paymentMethod: SessionPaymentMethod }>, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null, groupUsers?: Array<{ __typename: 'GroupUserType', id: string } | null> | null } }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserQuery = { __typename: 'Query', user?: { __typename: 'UserType', id: string, uuid?: string | null, name: string, surname: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isAdmin: boolean, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } }> } | null };

export type ActivitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitesQuery = { __typename: 'Query', activities?: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null> | null };

export type OrganisedSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisedSessionsQuery = { __typename: 'Query', organisedSessions?: Array<{ __typename: 'SessionType', id: string, uuid: string, createdAt: string, name: string, image: string, startAt: string, endAt?: string | null, status?: string | null, usersAttendingCount: number, isUserAttending: boolean, isJoinable: boolean, gender?: string | null, skillLevel: SessionSkillLevel, venueType: SessionVenueType, minAge?: number | null, maxAge?: number | null, minParticipants?: number | null, maxParticipants?: number | null, address: string, addressLatitude?: number | null, addressLongitude?: number | null, description: string, cancellationReason: string, rules: string, notes: string, isPrivate: boolean, paymentMethod: SessionPaymentMethod, isOwner: boolean, membership: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', uuid?: string | null, id: string, name: string, surname: string, avatar: string }, price?: { __typename: 'PriceType', id: string, uuid: string, value: number, description: string } | null }>, membershipAttending?: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } }> | null, owner?: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null>, links?: Array<{ __typename: 'LinkType', id: string, name: string, url: string }> | null, prices?: Array<{ __typename: 'PriceType', id: string, uuid: string, description: string, value: number }> | null, group: { __typename: 'GroupType', id: string, uuid: string, isPrivate: boolean, isMember: boolean, isOwner: boolean, isAdmin: boolean, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, name: string, endAt?: string | null }> } }> | null };

export type SessionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SessionQuery = { __typename: 'Query', session: { __typename: 'SessionType', id: string, uuid: string, createdAt: string, name: string, image: string, startAt: string, endAt?: string | null, status?: string | null, usersAttendingCount: number, isUserAttending: boolean, isJoinable: boolean, gender?: string | null, skillLevel: SessionSkillLevel, venueType: SessionVenueType, minAge?: number | null, maxAge?: number | null, minParticipants?: number | null, maxParticipants?: number | null, address: string, addressLatitude?: number | null, addressLongitude?: number | null, description: string, cancellationReason: string, rules: string, notes: string, isPrivate: boolean, paymentMethod: SessionPaymentMethod, isOwner: boolean, membership: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', uuid?: string | null, id: string, name: string, surname: string, avatar: string }, price?: { __typename: 'PriceType', id: string, uuid: string, value: number, description: string } | null }>, membershipAttending?: Array<{ __typename: 'MembershipType', id: string, uuid: string, attendance?: boolean | null, status: MembershipStatus, createdAt: string, paymentMethod?: MembershipPaymentMethod | null, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } }> | null, owner?: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, name: string, isFeatured: boolean, icon: string, defaultBannerImage: string } | null>, links?: Array<{ __typename: 'LinkType', id: string, name: string, url: string }> | null, prices?: Array<{ __typename: 'PriceType', id: string, uuid: string, description: string, value: number }> | null, group: { __typename: 'GroupType', id: string, uuid: string, isPrivate: boolean, isMember: boolean, isOwner: boolean, isAdmin: boolean, sessions: Array<{ __typename: 'SessionType', id: string, startAt: string, status?: string | null, name: string, endAt?: string | null }> } } };

export type SessionMembershipQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Array<InputMaybe<MembershipStatusEnum>> | InputMaybe<MembershipStatusEnum>>;
  startAt_Gte?: InputMaybe<Scalars['DateTime']>;
  startAt_Lte?: InputMaybe<Scalars['DateTime']>;
}>;


export type SessionMembershipQuery = { __typename: 'Query', sessionMembership?: Array<{ __typename: 'MembershipType', id: string, status: MembershipStatus, bankedPaymentId?: string | null, price?: { __typename: 'PriceType', id: string, uuid: string, value: number } | null, session: { __typename: 'SessionType', id: string, status?: string | null, startAt: string, name: string, image: string, isOwner: boolean, address: string, createdAt: string, maxParticipants?: number | null, usersAttendingCount: number, group: { __typename: 'GroupType', id: string, uuid: string }, owner?: { __typename: 'UserType', id: string } | null, activity: Array<{ __typename: 'ActivityType', id: string, defaultBannerImage: string, name: string } | null> } }> | null };

export type UserNotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type UserNotificationsQuery = { __typename: 'Query', userNotifications: Array<{ __typename: 'UserNotificationType', uuid?: string | null, message?: string | null, data?: any | null, createdAt?: string | null, user?: { __typename: 'UserType', id: string, email: string, name: string, avatar: string } | null } | null> };

export type MembershipQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
}>;


export type MembershipQuery = { __typename: 'Query', membership?: { __typename: 'MembershipType', id: string, uuid: string, paymentMethod?: MembershipPaymentMethod | null, bankedPaymentId?: string | null, bankedPaymentStatus?: string | null, status: MembershipStatus, createdAt: string, user: { __typename: 'UserType', id: string, email: string, name: string, avatar: string } } | null };

export type GroupQueryVariables = Exact<{
  groupUuid?: InputMaybe<Scalars['String']>;
}>;


export type GroupQuery = { __typename: 'Query', group?: { __typename: 'GroupType', id: string, uuid: string, createdAt: string, updatedAt: string, name: string, image: string, isOwner: boolean, isAdmin: boolean, isActive: boolean, isMember: boolean, isPrivate: boolean, description: string, userCount?: boolean | null, hasRequested?: boolean | null, groupUsers?: Array<{ __typename: 'GroupUserType', id: string, isAdmin: boolean, createdAt: string, user: { __typename: 'UserType', id: string, name: string, surname: string, avatar: string, email: string } } | null> | null, groupRequests: Array<{ __typename: 'GroupRequestType', uuid: string, createdAt: string, updatedAt: string, id: string }>, sessions: Array<{ __typename: 'SessionType', id: string, uuid: string, name: string, image: string, address: string, status?: string | null, isUserAttending: boolean, startAt: string, endAt?: string | null, maxParticipants?: number | null, usersAttendingCount: number, activity: Array<{ __typename: 'ActivityType', id: string, defaultBannerImage: string, name: string } | null>, owner?: { __typename: 'UserType', id: string, name: string } | null, membership: Array<{ __typename: 'MembershipType', id: string, status: MembershipStatus }> }>, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } | null };

export type GroupRequestsQueryVariables = Exact<{
  groupUuid?: InputMaybe<Scalars['String']>;
}>;


export type GroupRequestsQuery = { __typename: 'Query', groupRequests?: Array<{ __typename: 'GroupRequestType', uuid: string, createdAt: string, updatedAt: string, id: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string }, requestUser: { __typename: 'UserType', id: string, name: string, surname: string, email: string, avatar: string } } | null> | null };

export type WallPostsQueryVariables = Exact<{
  groupUuid: Scalars['ID'];
  parentUuid?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type WallPostsQuery = { __typename: 'Query', wallPosts: Array<{ __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean, user: { __typename: 'UserType', id: string, uuid?: string | null, name: string, surname: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isAdmin: boolean, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } }> }, wall: { __typename: 'WallType', uuid: string, group: { __typename: 'GroupType', uuid: string, isAdmin: boolean, isOwner: boolean } }, parent?: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean } | null }> };

export type WallPostQueryVariables = Exact<{
  postUuid: Scalars['ID'];
}>;


export type WallPostQuery = { __typename: 'Query', wallPost: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean, user: { __typename: 'UserType', id: string, uuid?: string | null, name: string, surname: string, dateJoined: string, organisedEventsCount?: number | null, attendingSessionCount?: number | null, avatar: string, groupuserSet: Array<{ __typename: 'GroupUserType', id: string, uuid: string, group: { __typename: 'GroupType', id: string, uuid: string, name: string, image: string, isAdmin: boolean, activities?: Array<{ __typename: 'ActivityType', id: string, name: string } | null> | null } }> }, wall: { __typename: 'WallType', uuid: string, group: { __typename: 'GroupType', uuid: string, isAdmin: boolean, isOwner: boolean } }, parent?: { __typename: 'WallPostType', uuid: string, content: string, reactionCount: number, postCount: number, userHasLiked: boolean, createdAt: string, updatedAt: string, isAdmin: boolean } | null } };

export const SessionFragmentDoc = gql`
    fragment Session on SessionType {
  id
  uuid
  createdAt
  name
  image
  startAt
  endAt
  status
  membership {
    id
    uuid
    attendance
    status
    createdAt
    user {
      uuid
      id
      name
      surname
      avatar
    }
    price {
      id
      uuid
      value
      description
    }
    paymentMethod
  }
  membershipAttending {
    id
    uuid
    attendance
    status
    createdAt
    user {
      id
      name
      surname
      avatar
    }
    paymentMethod
  }
  owner {
    id
    name
    surname
    avatar
  }
  activity {
    id
    name
    isFeatured
    icon
    defaultBannerImage
  }
  usersAttendingCount
  isUserAttending
  isJoinable
  gender
  skillLevel
  venueType
  minAge
  maxAge
  minParticipants
  maxParticipants
  address
  addressLatitude
  addressLongitude
  description
  cancellationReason
  rules
  notes
  isPrivate
  paymentMethod
  isOwner
  links {
    id
    name
    url
  }
  prices {
    id
    uuid
    description
    value
  }
  group {
    id
    uuid
    isPrivate
    isMember
    isOwner
    isAdmin
    sessions {
      id
      startAt
      status
      name
      endAt
    }
  }
}
    `;
export const MeUserFragmentDoc = gql`
    fragment MeUser on MeType {
  id
  uuid
  name
  surname
  email
  dateJoined
  organisedEventsCount
  attendingSessionCount
  avatar
  defaultAddress
  defaultAddressLatitude
  defaultAddressLongitude
  useDefaultAddress
  accountName
  accountNumber
  accountSortCode
  passwordResetCode
  verificationCode
  isEmailVerified
  groupuserSet {
    id
    uuid
    group {
      id
      uuid
      name
      image
      isActive
      isPrivate
      isOwner
      isMember
      isAdmin
      hasRequested
      sessions {
        id
        startAt
        status
        paymentMethod
      }
      activities {
        id
        name
      }
      userCount
      groupUsers {
        id
      }
    }
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserType {
  id
  uuid
  name
  surname
  dateJoined
  organisedEventsCount
  attendingSessionCount
  avatar
  groupuserSet {
    id
    uuid
    group {
      id
      uuid
      name
      image
      isAdmin
      activities {
        id
        name
      }
    }
  }
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on GroupType {
  id
  uuid
  createdAt
  updatedAt
  name
  image
  isOwner
  isAdmin
  isActive
  isMember
  isPrivate
  description
  groupUsers {
    id
    isAdmin
    createdAt
    user {
      id
      name
      surname
      avatar
      email
    }
  }
  groupRequests {
    uuid
    createdAt
    updatedAt
    id
  }
  sessions {
    id
    uuid
    name
    image
    address
    status
    isUserAttending
    startAt
    endAt
    maxParticipants
    usersAttendingCount
    activity {
      id
      defaultBannerImage
      name
    }
    owner {
      id
      name
    }
    membership {
      id
      status
    }
  }
  activities {
    id
    name
  }
  userCount
  hasRequested
}
    `;
export const WallPostFragmentDoc = gql`
    fragment WallPost on WallPostType {
  uuid
  content
  reactionCount
  postCount
  userHasLiked
  createdAt
  updatedAt
  isAdmin
}
    `;
export const WallFragmentDoc = gql`
    fragment Wall on WallType {
  uuid
  group {
    uuid
    isAdmin
    isOwner
  }
}
    `;
export const LoginMutationDocument = gql`
    mutation loginMutation($email: String!, $password: String!) {
  tokenAuth(email: $email, password: $password) {
    token
  }
}
    `;
export type LoginMutationMutationFn = Apollo.MutationFunction<LoginMutationMutation, LoginMutationMutationVariables>;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutationMutation, { data, loading, error }] = useLoginMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationMutation, LoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
      }
export type LoginMutationMutationHookResult = ReturnType<typeof useLoginMutationMutation>;
export type LoginMutationMutationResult = Apollo.MutationResult<LoginMutationMutation>;
export type LoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($name: String!, $surname: String, $email: String!, $password: String!, $activities: [Int!], $avatar: Upload) {
  createUser(
    input: {name: $name, surname: $surname, email: $email, password: $password, activities: $activities, avatar: $avatar}
  ) {
    token
    user {
      id
      name
      surname
      email
      avatar
      isEmailVerified
      activities {
        id
        name
      }
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      surname: // value for 'surname'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      activities: // value for 'activities'
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($name: String, $surname: String, $email: String, $newPassword: String, $newAvatar: Upload, $accountName: String!, $accountNumber: String, $accountSortCode: String) {
  updateUser(
    input: {name: $name, surname: $surname, email: $email, newPassword: $newPassword, newAvatar: $newAvatar, accountName: $accountName, accountNumber: $accountNumber, accountSortCode: $accountSortCode}
  ) {
    user {
      id
      name
      surname
      email
      avatar
      accountSortCode
      activities {
        id
        name
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      surname: // value for 'surname'
 *      email: // value for 'email'
 *      newPassword: // value for 'newPassword'
 *      newAvatar: // value for 'newAvatar'
 *      accountName: // value for 'accountName'
 *      accountNumber: // value for 'accountNumber'
 *      accountSortCode: // value for 'accountSortCode'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserPushDocument = gql`
    mutation updateUserPush($pushNotificationToken: String) {
  updateUser(input: {pushNotificationToken: $pushNotificationToken}) {
    user {
      id
    }
  }
}
    `;
export type UpdateUserPushMutationFn = Apollo.MutationFunction<UpdateUserPushMutation, UpdateUserPushMutationVariables>;

/**
 * __useUpdateUserPushMutation__
 *
 * To run a mutation, you first call `useUpdateUserPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPushMutation, { data, loading, error }] = useUpdateUserPushMutation({
 *   variables: {
 *      pushNotificationToken: // value for 'pushNotificationToken'
 *   },
 * });
 */
export function useUpdateUserPushMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPushMutation, UpdateUserPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPushMutation, UpdateUserPushMutationVariables>(UpdateUserPushDocument, options);
      }
export type UpdateUserPushMutationHookResult = ReturnType<typeof useUpdateUserPushMutation>;
export type UpdateUserPushMutationResult = Apollo.MutationResult<UpdateUserPushMutation>;
export type UpdateUserPushMutationOptions = Apollo.BaseMutationOptions<UpdateUserPushMutation, UpdateUserPushMutationVariables>;
export const CreateMultipleSessionsDocument = gql`
    mutation createMultipleSessions($name: String!, $groupUuid: String!, $activityId: Int!, $prices: [PriceInput]!, $links: [LinkInput], $gender: SessionGenderEnum, $skillLevel: SessionSkillLevelEnum!, $venueType: SessionVenueTypeEnum!, $refundPolicy: SessionRefundPolicyEnum!, $paymentMethod: SessionPaymentMethodEnum, $minAge: Int, $maxAge: Int, $minParticipants: Int, $maxParticipants: Int, $address: String!, $addressLatitude: Float!, $addressLongitude: Float!, $description: String, $rules: String, $notes: String, $isPrivate: Boolean, $isAcceptingCash: Boolean, $image: Upload, $dates: [CreateSessionDateInput]!) {
  createMultipleSessions(
    input: {name: $name, groupUuid: $groupUuid, activityId: $activityId, prices: $prices, links: $links, gender: $gender, skillLevel: $skillLevel, venueType: $venueType, refundPolicy: $refundPolicy, paymentMethod: $paymentMethod, minAge: $minAge, maxAge: $maxAge, minParticipants: $minParticipants, maxParticipants: $maxParticipants, address: $address, addressLatitude: $addressLatitude, addressLongitude: $addressLongitude, description: $description, rules: $rules, notes: $notes, isPrivate: $isPrivate, isAcceptingCash: $isAcceptingCash, image: $image, dates: $dates}
  ) {
    ok
  }
}
    `;
export type CreateMultipleSessionsMutationFn = Apollo.MutationFunction<CreateMultipleSessionsMutation, CreateMultipleSessionsMutationVariables>;

/**
 * __useCreateMultipleSessionsMutation__
 *
 * To run a mutation, you first call `useCreateMultipleSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleSessionsMutation, { data, loading, error }] = useCreateMultipleSessionsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      groupUuid: // value for 'groupUuid'
 *      activityId: // value for 'activityId'
 *      prices: // value for 'prices'
 *      links: // value for 'links'
 *      gender: // value for 'gender'
 *      skillLevel: // value for 'skillLevel'
 *      venueType: // value for 'venueType'
 *      refundPolicy: // value for 'refundPolicy'
 *      paymentMethod: // value for 'paymentMethod'
 *      minAge: // value for 'minAge'
 *      maxAge: // value for 'maxAge'
 *      minParticipants: // value for 'minParticipants'
 *      maxParticipants: // value for 'maxParticipants'
 *      address: // value for 'address'
 *      addressLatitude: // value for 'addressLatitude'
 *      addressLongitude: // value for 'addressLongitude'
 *      description: // value for 'description'
 *      rules: // value for 'rules'
 *      notes: // value for 'notes'
 *      isPrivate: // value for 'isPrivate'
 *      isAcceptingCash: // value for 'isAcceptingCash'
 *      image: // value for 'image'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useCreateMultipleSessionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultipleSessionsMutation, CreateMultipleSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultipleSessionsMutation, CreateMultipleSessionsMutationVariables>(CreateMultipleSessionsDocument, options);
      }
export type CreateMultipleSessionsMutationHookResult = ReturnType<typeof useCreateMultipleSessionsMutation>;
export type CreateMultipleSessionsMutationResult = Apollo.MutationResult<CreateMultipleSessionsMutation>;
export type CreateMultipleSessionsMutationOptions = Apollo.BaseMutationOptions<CreateMultipleSessionsMutation, CreateMultipleSessionsMutationVariables>;
export const UpdateSessionWithImageDocument = gql`
    mutation updateSessionWithImage($id: Int!, $name: String, $activityId: Int, $gender: SessionGenderEnum, $skillLevel: SessionSkillLevelEnum!, $venueType: SessionVenueTypeEnum!, $paymentMethod: SessionPaymentMethodEnum, $image: Upload, $minAge: Int, $maxAge: Int, $minParticipants: Int, $maxParticipants: Int, $address: String!, $addressLatitude: Float!, $addressLongitude: Float!, $description: String, $notes: String, $isPrivate: Boolean, $startAt: DateTime!, $endAt: DateTime) {
  updateSession(
    input: {id: $id, name: $name, activityId: $activityId, gender: $gender, skillLevel: $skillLevel, paymentMethod: $paymentMethod, image: $image, minAge: $minAge, maxAge: $maxAge, minParticipants: $minParticipants, maxParticipants: $maxParticipants, address: $address, addressLatitude: $addressLatitude, addressLongitude: $addressLongitude, description: $description, notes: $notes, venueType: $venueType, isPrivate: $isPrivate, startAt: $startAt, endAt: $endAt}
  ) {
    ok
    session {
      ...Session
    }
  }
}
    ${SessionFragmentDoc}`;
export type UpdateSessionWithImageMutationFn = Apollo.MutationFunction<UpdateSessionWithImageMutation, UpdateSessionWithImageMutationVariables>;

/**
 * __useUpdateSessionWithImageMutation__
 *
 * To run a mutation, you first call `useUpdateSessionWithImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionWithImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionWithImageMutation, { data, loading, error }] = useUpdateSessionWithImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      activityId: // value for 'activityId'
 *      gender: // value for 'gender'
 *      skillLevel: // value for 'skillLevel'
 *      venueType: // value for 'venueType'
 *      paymentMethod: // value for 'paymentMethod'
 *      image: // value for 'image'
 *      minAge: // value for 'minAge'
 *      maxAge: // value for 'maxAge'
 *      minParticipants: // value for 'minParticipants'
 *      maxParticipants: // value for 'maxParticipants'
 *      address: // value for 'address'
 *      addressLatitude: // value for 'addressLatitude'
 *      addressLongitude: // value for 'addressLongitude'
 *      description: // value for 'description'
 *      notes: // value for 'notes'
 *      isPrivate: // value for 'isPrivate'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useUpdateSessionWithImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionWithImageMutation, UpdateSessionWithImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionWithImageMutation, UpdateSessionWithImageMutationVariables>(UpdateSessionWithImageDocument, options);
      }
export type UpdateSessionWithImageMutationHookResult = ReturnType<typeof useUpdateSessionWithImageMutation>;
export type UpdateSessionWithImageMutationResult = Apollo.MutationResult<UpdateSessionWithImageMutation>;
export type UpdateSessionWithImageMutationOptions = Apollo.BaseMutationOptions<UpdateSessionWithImageMutation, UpdateSessionWithImageMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($id: Int!, $name: String, $activityId: Int, $gender: SessionGenderEnum, $skillLevel: SessionSkillLevelEnum!, $venueType: SessionVenueTypeEnum!, $paymentMethod: SessionPaymentMethodEnum, $minAge: Int, $maxAge: Int, $minParticipants: Int, $maxParticipants: Int, $address: String!, $addressLatitude: Float!, $addressLongitude: Float!, $description: String, $notes: String, $isPrivate: Boolean, $startAt: DateTime!, $endAt: DateTime) {
  updateSession(
    input: {id: $id, name: $name, activityId: $activityId, gender: $gender, skillLevel: $skillLevel, paymentMethod: $paymentMethod, minAge: $minAge, maxAge: $maxAge, minParticipants: $minParticipants, maxParticipants: $maxParticipants, address: $address, addressLatitude: $addressLatitude, addressLongitude: $addressLongitude, description: $description, notes: $notes, venueType: $venueType, isPrivate: $isPrivate, startAt: $startAt, endAt: $endAt}
  ) {
    ok
    session {
      ...Session
    }
  }
}
    ${SessionFragmentDoc}`;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      activityId: // value for 'activityId'
 *      gender: // value for 'gender'
 *      skillLevel: // value for 'skillLevel'
 *      venueType: // value for 'venueType'
 *      paymentMethod: // value for 'paymentMethod'
 *      minAge: // value for 'minAge'
 *      maxAge: // value for 'maxAge'
 *      minParticipants: // value for 'minParticipants'
 *      maxParticipants: // value for 'maxParticipants'
 *      address: // value for 'address'
 *      addressLatitude: // value for 'addressLatitude'
 *      addressLongitude: // value for 'addressLongitude'
 *      description: // value for 'description'
 *      notes: // value for 'notes'
 *      isPrivate: // value for 'isPrivate'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const JoinSessionDocument = gql`
    mutation joinSession($priceId: Int!, $sessionId: Int!, $paymentMethod: SessionPaymentMethodEnum!, $isExpo: Boolean) {
  joinSession(
    input: {priceId: $priceId, sessionId: $sessionId, paymentMethod: $paymentMethod, isExpo: $isExpo}
  ) {
    ok
    membership {
      id
      session {
        id
      }
      user {
        id
      }
      status
      createdAt
      updatedAt
      bankedPaymentId
      bankedPaymentStatus
    }
  }
}
    `;
export type JoinSessionMutationFn = Apollo.MutationFunction<JoinSessionMutation, JoinSessionMutationVariables>;

/**
 * __useJoinSessionMutation__
 *
 * To run a mutation, you first call `useJoinSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSessionMutation, { data, loading, error }] = useJoinSessionMutation({
 *   variables: {
 *      priceId: // value for 'priceId'
 *      sessionId: // value for 'sessionId'
 *      paymentMethod: // value for 'paymentMethod'
 *      isExpo: // value for 'isExpo'
 *   },
 * });
 */
export function useJoinSessionMutation(baseOptions?: Apollo.MutationHookOptions<JoinSessionMutation, JoinSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinSessionMutation, JoinSessionMutationVariables>(JoinSessionDocument, options);
      }
export type JoinSessionMutationHookResult = ReturnType<typeof useJoinSessionMutation>;
export type JoinSessionMutationResult = Apollo.MutationResult<JoinSessionMutation>;
export type JoinSessionMutationOptions = Apollo.BaseMutationOptions<JoinSessionMutation, JoinSessionMutationVariables>;
export const JoinSessionWaitingListDocument = gql`
    mutation joinSessionWaitingList($sessionId: Int!) {
  joinSessionWaitingList(input: {sessionId: $sessionId}) {
    ok
  }
}
    `;
export type JoinSessionWaitingListMutationFn = Apollo.MutationFunction<JoinSessionWaitingListMutation, JoinSessionWaitingListMutationVariables>;

/**
 * __useJoinSessionWaitingListMutation__
 *
 * To run a mutation, you first call `useJoinSessionWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSessionWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSessionWaitingListMutation, { data, loading, error }] = useJoinSessionWaitingListMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useJoinSessionWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<JoinSessionWaitingListMutation, JoinSessionWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinSessionWaitingListMutation, JoinSessionWaitingListMutationVariables>(JoinSessionWaitingListDocument, options);
      }
export type JoinSessionWaitingListMutationHookResult = ReturnType<typeof useJoinSessionWaitingListMutation>;
export type JoinSessionWaitingListMutationResult = Apollo.MutationResult<JoinSessionWaitingListMutation>;
export type JoinSessionWaitingListMutationOptions = Apollo.BaseMutationOptions<JoinSessionWaitingListMutation, JoinSessionWaitingListMutationVariables>;
export const LeaveSessionDocument = gql`
    mutation leaveSession($sessionId: Int!) {
  leaveSession(input: {sessionId: $sessionId}) {
    ok
  }
}
    `;
export type LeaveSessionMutationFn = Apollo.MutationFunction<LeaveSessionMutation, LeaveSessionMutationVariables>;

/**
 * __useLeaveSessionMutation__
 *
 * To run a mutation, you first call `useLeaveSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveSessionMutation, { data, loading, error }] = useLeaveSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useLeaveSessionMutation(baseOptions?: Apollo.MutationHookOptions<LeaveSessionMutation, LeaveSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveSessionMutation, LeaveSessionMutationVariables>(LeaveSessionDocument, options);
      }
export type LeaveSessionMutationHookResult = ReturnType<typeof useLeaveSessionMutation>;
export type LeaveSessionMutationResult = Apollo.MutationResult<LeaveSessionMutation>;
export type LeaveSessionMutationOptions = Apollo.BaseMutationOptions<LeaveSessionMutation, LeaveSessionMutationVariables>;
export const CancelSessionDocument = gql`
    mutation cancelSession($sessionId: Int!, $reason: String) {
  cancelSession(input: {sessionId: $sessionId, reason: $reason}) {
    ok
  }
}
    `;
export type CancelSessionMutationFn = Apollo.MutationFunction<CancelSessionMutation, CancelSessionMutationVariables>;

/**
 * __useCancelSessionMutation__
 *
 * To run a mutation, you first call `useCancelSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSessionMutation, { data, loading, error }] = useCancelSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelSessionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSessionMutation, CancelSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSessionMutation, CancelSessionMutationVariables>(CancelSessionDocument, options);
      }
export type CancelSessionMutationHookResult = ReturnType<typeof useCancelSessionMutation>;
export type CancelSessionMutationResult = Apollo.MutationResult<CancelSessionMutation>;
export type CancelSessionMutationOptions = Apollo.BaseMutationOptions<CancelSessionMutation, CancelSessionMutationVariables>;
export const CreateFeedbackEntryDocument = gql`
    mutation createFeedbackEntry($message: String!) {
  createFeedbackEntry(input: {message: $message}) {
    ok
    entry {
      message
    }
  }
}
    `;
export type CreateFeedbackEntryMutationFn = Apollo.MutationFunction<CreateFeedbackEntryMutation, CreateFeedbackEntryMutationVariables>;

/**
 * __useCreateFeedbackEntryMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackEntryMutation, { data, loading, error }] = useCreateFeedbackEntryMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateFeedbackEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackEntryMutation, CreateFeedbackEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackEntryMutation, CreateFeedbackEntryMutationVariables>(CreateFeedbackEntryDocument, options);
      }
export type CreateFeedbackEntryMutationHookResult = ReturnType<typeof useCreateFeedbackEntryMutation>;
export type CreateFeedbackEntryMutationResult = Apollo.MutationResult<CreateFeedbackEntryMutation>;
export type CreateFeedbackEntryMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackEntryMutation, CreateFeedbackEntryMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($name: String!, $description: String, $image: Upload, $isPrivate: Boolean!) {
  createGroup(
    input: {name: $name, description: $description, image: $image, isPrivate: $isPrivate}
  ) {
    ok
    group {
      uuid
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupWithImageDocument = gql`
    mutation updateGroupWithImage($groupUuid: String!, $name: String!, $description: String, $image: Upload, $isPrivate: Boolean!) {
  updateGroup(
    input: {groupUuid: $groupUuid, name: $name, description: $description, image: $image, isPrivate: $isPrivate}
  ) {
    ok
    group {
      uuid
    }
  }
}
    `;
export type UpdateGroupWithImageMutationFn = Apollo.MutationFunction<UpdateGroupWithImageMutation, UpdateGroupWithImageMutationVariables>;

/**
 * __useUpdateGroupWithImageMutation__
 *
 * To run a mutation, you first call `useUpdateGroupWithImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupWithImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupWithImageMutation, { data, loading, error }] = useUpdateGroupWithImageMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useUpdateGroupWithImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupWithImageMutation, UpdateGroupWithImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupWithImageMutation, UpdateGroupWithImageMutationVariables>(UpdateGroupWithImageDocument, options);
      }
export type UpdateGroupWithImageMutationHookResult = ReturnType<typeof useUpdateGroupWithImageMutation>;
export type UpdateGroupWithImageMutationResult = Apollo.MutationResult<UpdateGroupWithImageMutation>;
export type UpdateGroupWithImageMutationOptions = Apollo.BaseMutationOptions<UpdateGroupWithImageMutation, UpdateGroupWithImageMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($groupUuid: String!, $name: String!, $description: String, $isPrivate: Boolean!) {
  updateGroup(
    input: {groupUuid: $groupUuid, name: $name, description: $description, isPrivate: $isPrivate}
  ) {
    ok
    group {
      uuid
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation leaveGroup($groupUuid: String!) {
  leaveGroup(input: {groupUuid: $groupUuid}) {
    ok
  }
}
    `;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const JoinGroupDocument = gql`
    mutation joinGroup($groupUuid: String!) {
  joinGroup(input: {groupUuid: $groupUuid}) {
    ok
  }
}
    `;
export type JoinGroupMutationFn = Apollo.MutationFunction<JoinGroupMutation, JoinGroupMutationVariables>;

/**
 * __useJoinGroupMutation__
 *
 * To run a mutation, you first call `useJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupMutation, { data, loading, error }] = useJoinGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *   },
 * });
 */
export function useJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupMutation, JoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupMutation, JoinGroupMutationVariables>(JoinGroupDocument, options);
      }
export type JoinGroupMutationHookResult = ReturnType<typeof useJoinGroupMutation>;
export type JoinGroupMutationResult = Apollo.MutationResult<JoinGroupMutation>;
export type JoinGroupMutationOptions = Apollo.BaseMutationOptions<JoinGroupMutation, JoinGroupMutationVariables>;
export const ApproveRejectRequestJoinGroupDocument = gql`
    mutation approveRejectRequestJoinGroup($groupUuid: String!, $requestUserId: Int!, $accept: Boolean!) {
  approveRejectRequestJoinGroup(
    input: {groupUuid: $groupUuid, requestUserId: $requestUserId, accept: $accept}
  ) {
    ok
  }
}
    `;
export type ApproveRejectRequestJoinGroupMutationFn = Apollo.MutationFunction<ApproveRejectRequestJoinGroupMutation, ApproveRejectRequestJoinGroupMutationVariables>;

/**
 * __useApproveRejectRequestJoinGroupMutation__
 *
 * To run a mutation, you first call `useApproveRejectRequestJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRejectRequestJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRejectRequestJoinGroupMutation, { data, loading, error }] = useApproveRejectRequestJoinGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      requestUserId: // value for 'requestUserId'
 *      accept: // value for 'accept'
 *   },
 * });
 */
export function useApproveRejectRequestJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRejectRequestJoinGroupMutation, ApproveRejectRequestJoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRejectRequestJoinGroupMutation, ApproveRejectRequestJoinGroupMutationVariables>(ApproveRejectRequestJoinGroupDocument, options);
      }
export type ApproveRejectRequestJoinGroupMutationHookResult = ReturnType<typeof useApproveRejectRequestJoinGroupMutation>;
export type ApproveRejectRequestJoinGroupMutationResult = Apollo.MutationResult<ApproveRejectRequestJoinGroupMutation>;
export type ApproveRejectRequestJoinGroupMutationOptions = Apollo.BaseMutationOptions<ApproveRejectRequestJoinGroupMutation, ApproveRejectRequestJoinGroupMutationVariables>;
export const SetAdminGroupDocument = gql`
    mutation setAdminGroup($groupUuid: String!, $userId: Int!, $isAdmin: Boolean!) {
  setAdminGroup(
    input: {groupUuid: $groupUuid, userId: $userId, isAdmin: $isAdmin}
  ) {
    ok
  }
}
    `;
export type SetAdminGroupMutationFn = Apollo.MutationFunction<SetAdminGroupMutation, SetAdminGroupMutationVariables>;

/**
 * __useSetAdminGroupMutation__
 *
 * To run a mutation, you first call `useSetAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdminGroupMutation, { data, loading, error }] = useSetAdminGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      userId: // value for 'userId'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useSetAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetAdminGroupMutation, SetAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdminGroupMutation, SetAdminGroupMutationVariables>(SetAdminGroupDocument, options);
      }
export type SetAdminGroupMutationHookResult = ReturnType<typeof useSetAdminGroupMutation>;
export type SetAdminGroupMutationResult = Apollo.MutationResult<SetAdminGroupMutation>;
export type SetAdminGroupMutationOptions = Apollo.BaseMutationOptions<SetAdminGroupMutation, SetAdminGroupMutationVariables>;
export const TransferGroupOwnershipDocument = gql`
    mutation transferGroupOwnership($groupUuid: String!, $userId: Int!) {
  transferGroupOwnership(input: {groupUuid: $groupUuid, userId: $userId}) {
    ok
  }
}
    `;
export type TransferGroupOwnershipMutationFn = Apollo.MutationFunction<TransferGroupOwnershipMutation, TransferGroupOwnershipMutationVariables>;

/**
 * __useTransferGroupOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferGroupOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferGroupOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferGroupOwnershipMutation, { data, loading, error }] = useTransferGroupOwnershipMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTransferGroupOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferGroupOwnershipMutation, TransferGroupOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferGroupOwnershipMutation, TransferGroupOwnershipMutationVariables>(TransferGroupOwnershipDocument, options);
      }
export type TransferGroupOwnershipMutationHookResult = ReturnType<typeof useTransferGroupOwnershipMutation>;
export type TransferGroupOwnershipMutationResult = Apollo.MutationResult<TransferGroupOwnershipMutation>;
export type TransferGroupOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferGroupOwnershipMutation, TransferGroupOwnershipMutationVariables>;
export const RemoveMemberGroupDocument = gql`
    mutation removeMemberGroup($groupUuid: String!, $userId: Int!) {
  removeMemberGroup(input: {groupUuid: $groupUuid, userId: $userId}) {
    ok
  }
}
    `;
export type RemoveMemberGroupMutationFn = Apollo.MutationFunction<RemoveMemberGroupMutation, RemoveMemberGroupMutationVariables>;

/**
 * __useRemoveMemberGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMemberGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberGroupMutation, { data, loading, error }] = useRemoveMemberGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberGroupMutation, RemoveMemberGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberGroupMutation, RemoveMemberGroupMutationVariables>(RemoveMemberGroupDocument, options);
      }
export type RemoveMemberGroupMutationHookResult = ReturnType<typeof useRemoveMemberGroupMutation>;
export type RemoveMemberGroupMutationResult = Apollo.MutationResult<RemoveMemberGroupMutation>;
export type RemoveMemberGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMemberGroupMutation, RemoveMemberGroupMutationVariables>;
export const CreateUpdateTrackTraceGroupDocument = gql`
    mutation createUpdateTrackTraceGroup($groupUuid: String!, $firstName: String!, $lastName: String!, $phoneNumber: String!, $email: String!) {
  createUpdateTrackTraceGroup(
    input: {groupUuid: $groupUuid, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, email: $email}
  ) {
    ok
  }
}
    `;
export type CreateUpdateTrackTraceGroupMutationFn = Apollo.MutationFunction<CreateUpdateTrackTraceGroupMutation, CreateUpdateTrackTraceGroupMutationVariables>;

/**
 * __useCreateUpdateTrackTraceGroupMutation__
 *
 * To run a mutation, you first call `useCreateUpdateTrackTraceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateTrackTraceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateTrackTraceGroupMutation, { data, loading, error }] = useCreateUpdateTrackTraceGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateUpdateTrackTraceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateTrackTraceGroupMutation, CreateUpdateTrackTraceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateTrackTraceGroupMutation, CreateUpdateTrackTraceGroupMutationVariables>(CreateUpdateTrackTraceGroupDocument, options);
      }
export type CreateUpdateTrackTraceGroupMutationHookResult = ReturnType<typeof useCreateUpdateTrackTraceGroupMutation>;
export type CreateUpdateTrackTraceGroupMutationResult = Apollo.MutationResult<CreateUpdateTrackTraceGroupMutation>;
export type CreateUpdateTrackTraceGroupMutationOptions = Apollo.BaseMutationOptions<CreateUpdateTrackTraceGroupMutation, CreateUpdateTrackTraceGroupMutationVariables>;
export const RequestTrackTraceGroupDocument = gql`
    mutation requestTrackTraceGroup($groupUuid: String!, $sessionUuid: String!) {
  requestTrackTraceGroup(
    input: {groupUuid: $groupUuid, sessionUuid: $sessionUuid}
  ) {
    ok
  }
}
    `;
export type RequestTrackTraceGroupMutationFn = Apollo.MutationFunction<RequestTrackTraceGroupMutation, RequestTrackTraceGroupMutationVariables>;

/**
 * __useRequestTrackTraceGroupMutation__
 *
 * To run a mutation, you first call `useRequestTrackTraceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTrackTraceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTrackTraceGroupMutation, { data, loading, error }] = useRequestTrackTraceGroupMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      sessionUuid: // value for 'sessionUuid'
 *   },
 * });
 */
export function useRequestTrackTraceGroupMutation(baseOptions?: Apollo.MutationHookOptions<RequestTrackTraceGroupMutation, RequestTrackTraceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTrackTraceGroupMutation, RequestTrackTraceGroupMutationVariables>(RequestTrackTraceGroupDocument, options);
      }
export type RequestTrackTraceGroupMutationHookResult = ReturnType<typeof useRequestTrackTraceGroupMutation>;
export type RequestTrackTraceGroupMutationResult = Apollo.MutationResult<RequestTrackTraceGroupMutation>;
export type RequestTrackTraceGroupMutationOptions = Apollo.BaseMutationOptions<RequestTrackTraceGroupMutation, RequestTrackTraceGroupMutationVariables>;
export const UpdateSessionAttendanceDocument = gql`
    mutation updateSessionAttendance($userId: Int!, $sessionUuid: String!, $attendance: Boolean!) {
  updateSessionAttendance(
    input: {userId: $userId, sessionUuid: $sessionUuid, attendance: $attendance}
  ) {
    ok
  }
}
    `;
export type UpdateSessionAttendanceMutationFn = Apollo.MutationFunction<UpdateSessionAttendanceMutation, UpdateSessionAttendanceMutationVariables>;

/**
 * __useUpdateSessionAttendanceMutation__
 *
 * To run a mutation, you first call `useUpdateSessionAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionAttendanceMutation, { data, loading, error }] = useUpdateSessionAttendanceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      sessionUuid: // value for 'sessionUuid'
 *      attendance: // value for 'attendance'
 *   },
 * });
 */
export function useUpdateSessionAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionAttendanceMutation, UpdateSessionAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionAttendanceMutation, UpdateSessionAttendanceMutationVariables>(UpdateSessionAttendanceDocument, options);
      }
export type UpdateSessionAttendanceMutationHookResult = ReturnType<typeof useUpdateSessionAttendanceMutation>;
export type UpdateSessionAttendanceMutationResult = Apollo.MutationResult<UpdateSessionAttendanceMutation>;
export type UpdateSessionAttendanceMutationOptions = Apollo.BaseMutationOptions<UpdateSessionAttendanceMutation, UpdateSessionAttendanceMutationVariables>;
export const TransferSessionDocument = gql`
    mutation transferSession($membershipUuid: String!, $priceUuid: String!) {
  transferSession(input: {membershipUuid: $membershipUuid, priceUuid: $priceUuid}) {
    ok
  }
}
    `;
export type TransferSessionMutationFn = Apollo.MutationFunction<TransferSessionMutation, TransferSessionMutationVariables>;

/**
 * __useTransferSessionMutation__
 *
 * To run a mutation, you first call `useTransferSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferSessionMutation, { data, loading, error }] = useTransferSessionMutation({
 *   variables: {
 *      membershipUuid: // value for 'membershipUuid'
 *      priceUuid: // value for 'priceUuid'
 *   },
 * });
 */
export function useTransferSessionMutation(baseOptions?: Apollo.MutationHookOptions<TransferSessionMutation, TransferSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferSessionMutation, TransferSessionMutationVariables>(TransferSessionDocument, options);
      }
export type TransferSessionMutationHookResult = ReturnType<typeof useTransferSessionMutation>;
export type TransferSessionMutationResult = Apollo.MutationResult<TransferSessionMutation>;
export type TransferSessionMutationOptions = Apollo.BaseMutationOptions<TransferSessionMutation, TransferSessionMutationVariables>;
export const PasswordResetDocument = gql`
    mutation passwordReset($email: String, $code: String!, $password: String!) {
  passwordReset(input: {code: $code, password: $password, email: $email}) {
    ok
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *      password: // value for 'password'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation sendPasswordResetEmail($email: String) {
  sendPasswordResetEmail(input: {email: $email}) {
    ok
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const VerifyUserDocument = gql`
    mutation verifyUser($code: String!) {
  verifyUser(input: {code: $code}) {
    ok
  }
}
    `;
export type VerifyUserMutationFn = Apollo.MutationFunction<VerifyUserMutation, VerifyUserMutationVariables>;

/**
 * __useVerifyUserMutation__
 *
 * To run a mutation, you first call `useVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserMutation, { data, loading, error }] = useVerifyUserMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyUserMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserMutation, VerifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(VerifyUserDocument, options);
      }
export type VerifyUserMutationHookResult = ReturnType<typeof useVerifyUserMutation>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<VerifyUserMutation, VerifyUserMutationVariables>;
export const SendVerificationEmailDocument = gql`
    mutation sendVerificationEmail {
  sendVerificationEmail {
    ok
  }
}
    `;
export type SendVerificationEmailMutationFn = Apollo.MutationFunction<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>(SendVerificationEmailDocument, options);
      }
export type SendVerificationEmailMutationHookResult = ReturnType<typeof useSendVerificationEmailMutation>;
export type SendVerificationEmailMutationResult = Apollo.MutationResult<SendVerificationEmailMutation>;
export type SendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;
export const WallCreatePostDocument = gql`
    mutation wallCreatePost($groupUuid: ID!, $parentUuid: ID, $content: String!) {
  wallCreatePost(
    input: {groupUuid: $groupUuid, parentUuid: $parentUuid, content: $content}
  ) {
    ok
    post {
      ...WallPost
      user {
        ...User
      }
      parent {
        ...WallPost
      }
      wall {
        ...Wall
      }
    }
  }
}
    ${WallPostFragmentDoc}
${UserFragmentDoc}
${WallFragmentDoc}`;
export type WallCreatePostMutationFn = Apollo.MutationFunction<WallCreatePostMutation, WallCreatePostMutationVariables>;

/**
 * __useWallCreatePostMutation__
 *
 * To run a mutation, you first call `useWallCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWallCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wallCreatePostMutation, { data, loading, error }] = useWallCreatePostMutation({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      parentUuid: // value for 'parentUuid'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useWallCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<WallCreatePostMutation, WallCreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WallCreatePostMutation, WallCreatePostMutationVariables>(WallCreatePostDocument, options);
      }
export type WallCreatePostMutationHookResult = ReturnType<typeof useWallCreatePostMutation>;
export type WallCreatePostMutationResult = Apollo.MutationResult<WallCreatePostMutation>;
export type WallCreatePostMutationOptions = Apollo.BaseMutationOptions<WallCreatePostMutation, WallCreatePostMutationVariables>;
export const WallEditPostDocument = gql`
    mutation wallEditPost($postUuid: ID!, $content: String!) {
  wallEditPost(input: {postUuid: $postUuid, content: $content}) {
    ok
    post {
      ...WallPost
    }
  }
}
    ${WallPostFragmentDoc}`;
export type WallEditPostMutationFn = Apollo.MutationFunction<WallEditPostMutation, WallEditPostMutationVariables>;

/**
 * __useWallEditPostMutation__
 *
 * To run a mutation, you first call `useWallEditPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWallEditPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wallEditPostMutation, { data, loading, error }] = useWallEditPostMutation({
 *   variables: {
 *      postUuid: // value for 'postUuid'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useWallEditPostMutation(baseOptions?: Apollo.MutationHookOptions<WallEditPostMutation, WallEditPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WallEditPostMutation, WallEditPostMutationVariables>(WallEditPostDocument, options);
      }
export type WallEditPostMutationHookResult = ReturnType<typeof useWallEditPostMutation>;
export type WallEditPostMutationResult = Apollo.MutationResult<WallEditPostMutation>;
export type WallEditPostMutationOptions = Apollo.BaseMutationOptions<WallEditPostMutation, WallEditPostMutationVariables>;
export const WallDeletePostDocument = gql`
    mutation wallDeletePost($postUuid: ID!) {
  wallDeletePost(input: {postUuid: $postUuid}) {
    ok
  }
}
    `;
export type WallDeletePostMutationFn = Apollo.MutationFunction<WallDeletePostMutation, WallDeletePostMutationVariables>;

/**
 * __useWallDeletePostMutation__
 *
 * To run a mutation, you first call `useWallDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWallDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wallDeletePostMutation, { data, loading, error }] = useWallDeletePostMutation({
 *   variables: {
 *      postUuid: // value for 'postUuid'
 *   },
 * });
 */
export function useWallDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<WallDeletePostMutation, WallDeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WallDeletePostMutation, WallDeletePostMutationVariables>(WallDeletePostDocument, options);
      }
export type WallDeletePostMutationHookResult = ReturnType<typeof useWallDeletePostMutation>;
export type WallDeletePostMutationResult = Apollo.MutationResult<WallDeletePostMutation>;
export type WallDeletePostMutationOptions = Apollo.BaseMutationOptions<WallDeletePostMutation, WallDeletePostMutationVariables>;
export const WallToggleReactionDocument = gql`
    mutation wallToggleReaction($postUuid: ID!) {
  wallToggleReaction(input: {postUuid: $postUuid}) {
    ok
    post {
      ...WallPost
    }
  }
}
    ${WallPostFragmentDoc}`;
export type WallToggleReactionMutationFn = Apollo.MutationFunction<WallToggleReactionMutation, WallToggleReactionMutationVariables>;

/**
 * __useWallToggleReactionMutation__
 *
 * To run a mutation, you first call `useWallToggleReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWallToggleReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wallToggleReactionMutation, { data, loading, error }] = useWallToggleReactionMutation({
 *   variables: {
 *      postUuid: // value for 'postUuid'
 *   },
 * });
 */
export function useWallToggleReactionMutation(baseOptions?: Apollo.MutationHookOptions<WallToggleReactionMutation, WallToggleReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WallToggleReactionMutation, WallToggleReactionMutationVariables>(WallToggleReactionDocument, options);
      }
export type WallToggleReactionMutationHookResult = ReturnType<typeof useWallToggleReactionMutation>;
export type WallToggleReactionMutationResult = Apollo.MutationResult<WallToggleReactionMutation>;
export type WallToggleReactionMutationOptions = Apollo.BaseMutationOptions<WallToggleReactionMutation, WallToggleReactionMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser {
  deleteUser {
    ok
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...MeUser
  }
}
    ${MeUserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserDocument = gql`
    query user($id: Int!) {
  user(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const ActivitesDocument = gql`
    query activites {
  activities {
    id
    name
    isFeatured
    icon
    defaultBannerImage
  }
}
    `;

/**
 * __useActivitesQuery__
 *
 * To run a query within a React component, call `useActivitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivitesQuery(baseOptions?: Apollo.QueryHookOptions<ActivitesQuery, ActivitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitesQuery, ActivitesQueryVariables>(ActivitesDocument, options);
      }
export function useActivitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitesQuery, ActivitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitesQuery, ActivitesQueryVariables>(ActivitesDocument, options);
        }
export type ActivitesQueryHookResult = ReturnType<typeof useActivitesQuery>;
export type ActivitesLazyQueryHookResult = ReturnType<typeof useActivitesLazyQuery>;
export type ActivitesQueryResult = Apollo.QueryResult<ActivitesQuery, ActivitesQueryVariables>;
export const OrganisedSessionsDocument = gql`
    query organisedSessions {
  organisedSessions {
    ...Session
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useOrganisedSessionsQuery__
 *
 * To run a query within a React component, call `useOrganisedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisedSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisedSessionsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisedSessionsQuery, OrganisedSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisedSessionsQuery, OrganisedSessionsQueryVariables>(OrganisedSessionsDocument, options);
      }
export function useOrganisedSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisedSessionsQuery, OrganisedSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisedSessionsQuery, OrganisedSessionsQueryVariables>(OrganisedSessionsDocument, options);
        }
export type OrganisedSessionsQueryHookResult = ReturnType<typeof useOrganisedSessionsQuery>;
export type OrganisedSessionsLazyQueryHookResult = ReturnType<typeof useOrganisedSessionsLazyQuery>;
export type OrganisedSessionsQueryResult = Apollo.QueryResult<OrganisedSessionsQuery, OrganisedSessionsQueryVariables>;
export const SessionDocument = gql`
    query session($id: Int!) {
  session(id: $id) {
    ...Session
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionQuery(baseOptions: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const SessionMembershipDocument = gql`
    query sessionMembership($limit: Int, $offset: Int, $orderBy: String, $status_In: [MembershipStatusEnum], $startAt_Gte: DateTime, $startAt_Lte: DateTime) {
  sessionMembership(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    status_In: $status_In
    startAt_Gte: $startAt_Gte
    startAt_Lte: $startAt_Lte
  ) {
    id
    status
    bankedPaymentId
    price {
      id
      uuid
      value
    }
    session {
      id
      status
      startAt
      name
      image
      isOwner
      address
      group {
        id
        uuid
      }
      owner {
        id
      }
      activity {
        id
        defaultBannerImage
        name
      }
      createdAt
      maxParticipants
      usersAttendingCount
    }
  }
}
    `;

/**
 * __useSessionMembershipQuery__
 *
 * To run a query within a React component, call `useSessionMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionMembershipQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      status_In: // value for 'status_In'
 *      startAt_Gte: // value for 'startAt_Gte'
 *      startAt_Lte: // value for 'startAt_Lte'
 *   },
 * });
 */
export function useSessionMembershipQuery(baseOptions?: Apollo.QueryHookOptions<SessionMembershipQuery, SessionMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionMembershipQuery, SessionMembershipQueryVariables>(SessionMembershipDocument, options);
      }
export function useSessionMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionMembershipQuery, SessionMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionMembershipQuery, SessionMembershipQueryVariables>(SessionMembershipDocument, options);
        }
export type SessionMembershipQueryHookResult = ReturnType<typeof useSessionMembershipQuery>;
export type SessionMembershipLazyQueryHookResult = ReturnType<typeof useSessionMembershipLazyQuery>;
export type SessionMembershipQueryResult = Apollo.QueryResult<SessionMembershipQuery, SessionMembershipQueryVariables>;
export const UserNotificationsDocument = gql`
    query userNotifications($limit: Int, $offset: Int, $orderBy: String) {
  userNotifications(limit: $limit, offset: $offset, orderBy: $orderBy) {
    uuid
    user {
      id
      email
      name
      avatar
    }
    message
    data
    createdAt
  }
}
    `;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const MembershipDocument = gql`
    query membership($id: Int, $sessionId: Int) {
  membership(id: $id, sessionId: $sessionId) {
    id
    uuid
    user {
      id
      email
      name
      avatar
    }
    paymentMethod
    bankedPaymentId
    bankedPaymentStatus
    status
    createdAt
  }
}
    `;

/**
 * __useMembershipQuery__
 *
 * To run a query within a React component, call `useMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useMembershipQuery(baseOptions?: Apollo.QueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, options);
      }
export function useMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, options);
        }
export type MembershipQueryHookResult = ReturnType<typeof useMembershipQuery>;
export type MembershipLazyQueryHookResult = ReturnType<typeof useMembershipLazyQuery>;
export type MembershipQueryResult = Apollo.QueryResult<MembershipQuery, MembershipQueryVariables>;
export const GroupDocument = gql`
    query group($groupUuid: String) {
  group(groupUuid: $groupUuid) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *   },
 * });
 */
export function useGroupQuery(baseOptions?: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupRequestsDocument = gql`
    query groupRequests($groupUuid: String) {
  groupRequests(groupUuid: $groupUuid) {
    uuid
    createdAt
    updatedAt
    id
    group {
      id
      uuid
      name
    }
    requestUser {
      id
      name
      surname
      email
      avatar
    }
  }
}
    `;

/**
 * __useGroupRequestsQuery__
 *
 * To run a query within a React component, call `useGroupRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupRequestsQuery({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *   },
 * });
 */
export function useGroupRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GroupRequestsQuery, GroupRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupRequestsQuery, GroupRequestsQueryVariables>(GroupRequestsDocument, options);
      }
export function useGroupRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupRequestsQuery, GroupRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupRequestsQuery, GroupRequestsQueryVariables>(GroupRequestsDocument, options);
        }
export type GroupRequestsQueryHookResult = ReturnType<typeof useGroupRequestsQuery>;
export type GroupRequestsLazyQueryHookResult = ReturnType<typeof useGroupRequestsLazyQuery>;
export type GroupRequestsQueryResult = Apollo.QueryResult<GroupRequestsQuery, GroupRequestsQueryVariables>;
export const WallPostsDocument = gql`
    query wallPosts($groupUuid: ID!, $parentUuid: ID, $limit: Int, $offset: Int) {
  wallPosts(
    groupUuid: $groupUuid
    parentUuid: $parentUuid
    limit: $limit
    offset: $offset
  ) {
    ...WallPost
    user {
      ...User
    }
    wall {
      ...Wall
    }
    parent {
      ...WallPost
    }
  }
}
    ${WallPostFragmentDoc}
${UserFragmentDoc}
${WallFragmentDoc}`;

/**
 * __useWallPostsQuery__
 *
 * To run a query within a React component, call `useWallPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWallPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWallPostsQuery({
 *   variables: {
 *      groupUuid: // value for 'groupUuid'
 *      parentUuid: // value for 'parentUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useWallPostsQuery(baseOptions: Apollo.QueryHookOptions<WallPostsQuery, WallPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WallPostsQuery, WallPostsQueryVariables>(WallPostsDocument, options);
      }
export function useWallPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WallPostsQuery, WallPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WallPostsQuery, WallPostsQueryVariables>(WallPostsDocument, options);
        }
export type WallPostsQueryHookResult = ReturnType<typeof useWallPostsQuery>;
export type WallPostsLazyQueryHookResult = ReturnType<typeof useWallPostsLazyQuery>;
export type WallPostsQueryResult = Apollo.QueryResult<WallPostsQuery, WallPostsQueryVariables>;
export const WallPostDocument = gql`
    query wallPost($postUuid: ID!) {
  wallPost(postUuid: $postUuid) {
    ...WallPost
    user {
      ...User
    }
    wall {
      ...Wall
    }
    parent {
      ...WallPost
    }
  }
}
    ${WallPostFragmentDoc}
${UserFragmentDoc}
${WallFragmentDoc}`;

/**
 * __useWallPostQuery__
 *
 * To run a query within a React component, call `useWallPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useWallPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWallPostQuery({
 *   variables: {
 *      postUuid: // value for 'postUuid'
 *   },
 * });
 */
export function useWallPostQuery(baseOptions: Apollo.QueryHookOptions<WallPostQuery, WallPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WallPostQuery, WallPostQueryVariables>(WallPostDocument, options);
      }
export function useWallPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WallPostQuery, WallPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WallPostQuery, WallPostQueryVariables>(WallPostDocument, options);
        }
export type WallPostQueryHookResult = ReturnType<typeof useWallPostQuery>;
export type WallPostLazyQueryHookResult = ReturnType<typeof useWallPostLazyQuery>;
export type WallPostQueryResult = Apollo.QueryResult<WallPostQuery, WallPostQueryVariables>;
export const namedOperations = {
  Query: {
    me: 'me',
    user: 'user',
    activites: 'activites',
    organisedSessions: 'organisedSessions',
    session: 'session',
    sessionMembership: 'sessionMembership',
    userNotifications: 'userNotifications',
    membership: 'membership',
    group: 'group',
    groupRequests: 'groupRequests',
    wallPosts: 'wallPosts',
    wallPost: 'wallPost'
  },
  Mutation: {
    loginMutation: 'loginMutation',
    createUser: 'createUser',
    updateUser: 'updateUser',
    updateUserPush: 'updateUserPush',
    createMultipleSessions: 'createMultipleSessions',
    updateSessionWithImage: 'updateSessionWithImage',
    updateSession: 'updateSession',
    joinSession: 'joinSession',
    joinSessionWaitingList: 'joinSessionWaitingList',
    leaveSession: 'leaveSession',
    cancelSession: 'cancelSession',
    createFeedbackEntry: 'createFeedbackEntry',
    createGroup: 'createGroup',
    updateGroupWithImage: 'updateGroupWithImage',
    updateGroup: 'updateGroup',
    leaveGroup: 'leaveGroup',
    joinGroup: 'joinGroup',
    approveRejectRequestJoinGroup: 'approveRejectRequestJoinGroup',
    setAdminGroup: 'setAdminGroup',
    transferGroupOwnership: 'transferGroupOwnership',
    removeMemberGroup: 'removeMemberGroup',
    createUpdateTrackTraceGroup: 'createUpdateTrackTraceGroup',
    requestTrackTraceGroup: 'requestTrackTraceGroup',
    updateSessionAttendance: 'updateSessionAttendance',
    transferSession: 'transferSession',
    passwordReset: 'passwordReset',
    sendPasswordResetEmail: 'sendPasswordResetEmail',
    verifyUser: 'verifyUser',
    sendVerificationEmail: 'sendVerificationEmail',
    wallCreatePost: 'wallCreatePost',
    wallEditPost: 'wallEditPost',
    wallDeletePost: 'wallDeletePost',
    wallToggleReaction: 'wallToggleReaction',
    deleteUser: 'deleteUser'
  },
  Fragment: {
    Session: 'Session',
    MeUser: 'MeUser',
    User: 'User',
    Group: 'Group',
    WallPost: 'WallPost',
    Wall: 'Wall'
  }
}